var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import isStandardErrorStatus from './isStandardErrorStatus';
import { Routes, knownBusinessErrors } from '../const';
var showAnswerEligibilityErrors = function (error) {
    var _a = error !== undefined && error, statusCode = _a.statusCode, businessCode = _a.businessCode;
    var isKnownErrorCode = knownBusinessErrors.includes(businessCode);
    var isStandardError = (!statusCode || isStandardErrorStatus(statusCode)) && !isKnownErrorCode;
    return {
        isBusinessError: isKnownErrorCode,
        isStandardError: isStandardError
    };
};
export var handleError = function (_a) {
    var error = _a.error, currentFlow = _a.currentFlow, currentRoute = _a.currentRoute, flow = _a.flow, setCurrentRoute = _a.setCurrentRoute;
    return __awaiter(void 0, void 0, void 0, function () {
        var isPlanEnrollmentApiCall, errorResponse, errorObj, _b, isStandardError, isBusinessError;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    isPlanEnrollmentApiCall = currentRoute && currentRoute === Routes.PLAN_CONFIRM;
                    // Handling Network errors since they don't return a response object
                    if (!error.response || isPlanEnrollmentApiCall) {
                        setCurrentRoute("".concat(currentFlow, ".error"));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (error === null || error === void 0 ? void 0 : error.response.json())];
                case 1:
                    errorResponse = _f.sent();
                    errorObj = {
                        statusCode: (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status,
                        businessCode: (_e = (_d = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.businessErrors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.code
                    };
                    _b = showAnswerEligibilityErrors(errorObj), isStandardError = _b.isStandardError, isBusinessError = _b.isBusinessError;
                    flow.onResetQuestionnaire();
                    if (isStandardError) {
                        setCurrentRoute("".concat(currentFlow, ".error"));
                        return [2 /*return*/];
                    }
                    if (isBusinessError) {
                        if (errorObj.statusCode === 422 && errorObj.businessCode === '600023') {
                            setCurrentRoute(Routes.PLAN_FORBEARANCE);
                        }
                        setCurrentRoute("".concat(currentFlow, ".contact"));
                    }
                    return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=handleError.js.map